/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { SkumapItemsAssociationsResult } from '../../models/skumap-items-associations-result';

export interface SkumapTemplatesTemplateIdAssociateGet$Params {
  'Active-Tenant-Identifier': string;
  templateId: string;
}

export function skumapTemplatesTemplateIdAssociateGet(http: HttpClient, rootUrl: string, params: SkumapTemplatesTemplateIdAssociateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapItemsAssociationsResult>> {
  const rb = new RequestBuilder(rootUrl, skumapTemplatesTemplateIdAssociateGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateId', params.templateId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & SkumapItemsAssociationsResult>;
    })
  );
}

skumapTemplatesTemplateIdAssociateGet.PATH = '/skumap/templates/{templateId}/associate';
